<div *ngIf="showNavbar">
  <app-navbar />
</div>

<div *ngIf="isMainPage()">
  <router-outlet></router-outlet>
</div>

<div *ngIf="!isMainPage()" class="no-horizontal-scroll">
  <div class="row">
    <div class="col-md-2">
      <app-sidebar></app-sidebar>
    </div>
    <div class="col-md-10">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-shared-notification />

<app-shared-loading-spinner />

<app-shared-scroll-to-top />
